<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label="附件：" prop="attachmentList">
            <el-upload
              drag
              action=""
              :http-request="uploadAttachment"
              :limit="1"
              :on-exceed="handleMax"
              :on-remove="deleteAttachment"
              :file-list="curdForm.attachmentList"
              ref="attachmentUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('curdForm')" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import { uploadFile } from "@/api/enrollment";
export default {
  components: { butn },
  data() {
    return {
      showAudio: false, //控制音频overlay
      showProgress: false,
      progress: {
        videoProgress: 0
      },
      checkpoint: null,
      rules: {
        attachmentList: [rulesFactory.required("请选择附件")]
      },
      curdTitle: "上传附件",
      CUFlag: false,
      curdForm: {
        attachmentList: []
      },
      enrollId: ""
    };
  },
  created() {
    var _this = this;
    vue.$on("uploadFile", function(item) {
      _this.$nextTick(() => {
        _this.CUFlag = true;
        _this.enrollId = item.uuid;
      });
    });
  },
  methods: {
    // 上传附件
    uploadAttachment(e) {
      let file = e.file;
      let _this = this;
      // 显示文件上传进度
      FileHandler.uploadFile(`class/enroll`, file).then(res => {
        let obj = new Object();
        obj.url = res.url;
        obj.name = file.name;
        obj.path = res.name;
        _this.curdForm.attachmentList.push(obj);
      });
    },
    // 超出上传数量
    handleMax() {
      this.$message({
        message: "附件最多只能上传1个！",
        type: "warning"
      });
    },
    // 删除附件
    deleteAttachment(file) {
      for (var i = 0; i < this.curdForm.attachmentList.length; i++) {
        if (file.url == this.curdForm.attachmentList[i].url) {
          this.curdForm.attachmentList.splice(i, 1);
        }
      }
    },
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let params = {
            enrollId: this.enrollId
          };
          if (this.curdForm.attachmentList.length > 0) {
            params["attachment"] = JSON.stringify(this.curdForm.attachmentList);
          } else {
            params["attachment"] = null;
          }
          uploadFile(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              vue.$emit("tableInit");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped></style>
